import { useCallback, useState } from 'react'
import Checkbox from '../../../forms/Checkbox'
import { RectangularInputFormatNumberSmall } from '../../../forms/Input'
import { RangeTableDataDict } from '..'

interface RangeTableRowProps extends RangeTableRowLogicProps {
    tag: string
    ranges: number[]
    EditComponent?: React.ElementType
    editComponentProps?: any
}

const RangeTableRow: React.FC<RangeTableRowProps> = ({  tag, rangeData, ranges,  rangesLength, rowId, onChangeRangeRow, EditComponent, editComponentProps }) => {
    const { handleActiveRangeRow } = useRangeTableRowLogic({ rowId, rangeData, onChangeRangeRow, rangesLength })
    const rowRangeTableData = rangeData[rowId]
    const active = rowRangeTableData.active || false
    const renderRows: JSX.Element[] = []
    for (const key in ranges) {
        const range = ranges[key]
        let value = '0'
        if (rowRangeTableData?.values?.[key] !== undefined) {
            value = String(rowRangeTableData?.values?.[key])
        }
        renderRows.push(
            <RangeTableRowInput pos={parseInt(key)} {...{value, range, rangeData, onChangeRangeRow, rowId, key, tag, active}} />
        )
    }
    return (
        <div className='h-50 flex border-b-gray-EE border-b gap-x-5'>
            <div className='px-15 w-310 flex items-center'>
                <Checkbox  label={rowRangeTableData.name} checked={active} onChange={handleActiveRangeRow} />
                {EditComponent ? <EditComponent {...editComponentProps} allRowData={rowRangeTableData} parameterValue={rowRangeTableData.id} /> : null}
            </div>
            {renderRows}
        </div>
    )
}

interface RangeTableRowLogicProps {
    rangesLength: number
    rowId: number
    rangeData: RangeTableDataDict
    onChangeRangeRow: (rangeData: RangeTableDataDict)=>void
}

const useRangeTableRowLogic = ({ rangesLength, rowId, rangeData, onChangeRangeRow}: RangeTableRowLogicProps) => {
    const handleActiveRangeRow = useCallback((active: boolean) => {
        const dataCopy = JSON.parse(JSON.stringify(rangeData))
        dataCopy[rowId] = { ...dataCopy[rowId], values: rangeData[rowId].values || Array(rangesLength).fill(0), active }
        onChangeRangeRow(dataCopy)
    }, [onChangeRangeRow, rowId, rangeData, rangesLength])

    return { handleActiveRangeRow}
}


interface RangeTableRowInputProps extends RangeTableRowInputLogicProps {
    range: number
    active: boolean
    tag: string

}

const RangeTableRowInput: React.FC<RangeTableRowInputProps> = ({ range, active, tag, ...rest }) => {
    const { handleChangeRangeRow, myRangeRowValue, onBlurChangeRow } = useRangeTableRowInputLogic({ ...rest })
    return (
        <div className=' h-full flex items-center w-130 p-10 pr-22' key={range}>
            <div className='flex items-center input_quantity pl-17'>
                <RectangularInputFormatNumberSmall className='w-70 ' value={myRangeRowValue} readOnly={!active} onChange={(val) => handleChangeRangeRow(val)} onBlur={ onBlurChangeRow} />
                <span className='ml-10'>{tag}</span>
            </div>
        </div>
    )
}

interface RangeTableRowInputLogicProps {
    value: string
    rangeData: RangeTableDataDict
    rowId: number
    pos: number
    onChangeRangeRow: (rangeData: RangeTableDataDict) => void
}

const useRangeTableRowInputLogic = ({value, rangeData, onChangeRangeRow, rowId, pos}: RangeTableRowInputLogicProps) => {
    const [myRangeRowValue, setMyRangeRowValue] = useState<string>(value)

    const handleChangeRangeRow = useCallback((val: string) => {
        setMyRangeRowValue(val)
    }, [setMyRangeRowValue])

    const onBlurChangeRow = useCallback(() => {
        const dataCopy = JSON.parse(JSON.stringify(rangeData))
        dataCopy[rowId]?.values?.splice(pos, 1, parseFloat(myRangeRowValue))
        onChangeRangeRow(dataCopy)
    }, [onChangeRangeRow, rangeData, myRangeRowValue, rowId, pos])

    return { handleChangeRangeRow, myRangeRowValue, onBlurChangeRow }
}




export default RangeTableRow